import { SiteHeader } from '@/components/site-header'
import { Hero } from '@/components/hero'
import { Features } from '@/components/features'
import { GetStarted } from '@/components/get-started'
import { Download } from '@/components/download'
import { CommunityCallout } from '@/components/community-callout'
import { SiteFooter } from '@/components/site-footer'

export default function Page() {
  return (
    <div className="min-h-screen">
      <SiteHeader />
      <main>
        <Hero />
        <Features />
        <GetStarted />
        <Download />
        <CommunityCallout />
      </main>
      <SiteFooter />
    </div>
  )
}
